import type { IForecastIndex, IScenarioSubJob } from '@/interfaces'
import { ForecastIndex, ScenarioSubJob } from '@/models'
import { BaseService, type IAuthService } from '@/services'
import { APIEndpoints, APIScopes, APIURL } from '@/services/API'

export class ScenarioSubJobService extends BaseService {
	constructor(authService: IAuthService) {
		super(APIURL, authService, APIScopes)
	}

	async getIndex(params?: object): Promise<IForecastIndex[]> {
		console.log(params)
		return this.getData<IForecastIndex[]>(`${APIEndpoints.forecast}/`, params)
			.then((data) => {
				return data.map((c: IForecastIndex) => new ForecastIndex(c))
			})
			.catch((err) => {
				throw err
			})
	}

	async get(id: number): Promise<IScenarioSubJob> {
		return this.getData<IScenarioSubJob>(`${APIEndpoints.forecast}/${id}`)
			.then((data) => {
				return new ScenarioSubJob(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async getScenarios(id: number): Promise<IScenarioSubJob[]> {
		return this.getData<IScenarioSubJob[]>(`${APIEndpoints.forecast}/subjob/${id}`)
			.then((data) => {
				return data.map((c: IScenarioSubJob) => new ScenarioSubJob(c))
			})
			.catch((err) => {
				throw err
			})
	}

	async getBaseline(id: number): Promise<IScenarioSubJob> {
		return this.getData<IScenarioSubJob>(`${APIEndpoints.forecast}/baseline/${id}`)
			.then((data) => {
				return new ScenarioSubJob(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async add(subjob: ScenarioSubJob): Promise<IScenarioSubJob> {
		const obj = subjob
		console.log(obj)
		return this.postData<ScenarioSubJob, IScenarioSubJob>(`${APIEndpoints.forecast}/add`, obj)
			.then((res) => {
				console.log(res)
				return res as IScenarioSubJob
			})
			.catch((err) => {
				console.log('we have an error')
				throw err
			})
	}

	async update(subjob: ScenarioSubJob): Promise<ScenarioSubJob> {
		console.log(subjob)
		const obj = subjob
		return this.patchData(`${APIEndpoints.forecast}/update`, obj)
			.then((data) => {
				return new ScenarioSubJob(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async upsert(subjob: ScenarioSubJob): Promise<ScenarioSubJob> {
		console.log(subjob)
		const obj = subjob
		return this.patchData(`${APIEndpoints.forecast}/upsert`, obj)
			.then((data) => {
				return new ScenarioSubJob(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async commit(id: number): Promise<IScenarioSubJob> {
		return this.getData<IScenarioSubJob>(`${APIEndpoints.forecast}/commit/${id}`)
			.then((data) => {
				return new ScenarioSubJob(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async remove(id: number): Promise<IScenarioSubJob> {
		return this.getData<IScenarioSubJob>(`${APIEndpoints.forecast}/reset/${id}`)
			.then((data) => {
				return new ScenarioSubJob(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async hoursRatio(): Promise<number> {
		// return this.getData<number>(`${APIEndpoints.forecast}/hours-ratio`)
		// 	.then((data) => {
		// 		return data
		// 	})
		// 	.catch((err) => {
		// 		throw err
		// 	})
		return 0.0054647158667352
	}
}
